export default __webpack_public_path__ + "static/media/mystery-bronze-ticket.8b625b67.png";